import Vue from 'vue';
import App from './App.vue';
import Element from 'element-ui'

import "./styles/utils.scss";
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/common.css'

import router from './router'
import card from './components/card'
import axios from 'axios'
import { registerAuthExpired } from '@/utils/authExpired'
import VueParticles from 'vue-particles'

// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap'

Vue.config.productionTip = true;
Vue.prototype.$EventBus = new Vue()

Vue.use(Element)
Vue.use(card)
Vue.use(VueParticles)

// 直接在页面里 `import axios from 'axios'` 发的请求（未走 @/utils/request）也要在 401 时跳登录页
registerAuthExpired(axios)
new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
